import { useLegacyColors } from '@vrplatform/theme';
import {
  Anchor,
  Text,
  Title,
  type TitleProps,
  useMantineColorScheme,
} from '@mantine/core';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  crumbs?: { title: string; href: string }[];
  pageTitle: string;
  to?: string;
};
export const Breadcrumbs = ({
  crumbs,
  pageTitle,
  to,
  children: _,
  ...props
}: Props & TitleProps) => {
  const { colorScheme } = useMantineColorScheme();
  const { gray } = useLegacyColors();
  const isDarkMode = colorScheme === 'dark';

  const c = colorScheme === 'dark' ? 'white' : 'dark';

  if (!crumbs?.length) {
    return (
      <PageTitle {...props} fw={'bold'} c={c}>
        {pageTitle}
      </PageTitle>
    );
  }

  return (
    <PageTitle {...props}>
      {crumbs?.map((crumb) => (
        <Fragment key={crumb.title}>
          <Anchor
            inherit
            component={Link}
            c={isDarkMode ? gray.light : gray.dark + 90}
            to={crumb.href}
          >
            {crumb.title}
          </Anchor>{' '}
          /{' '}
        </Fragment>
      ))}
      {to ? (
        <Anchor component={Link} fw="bold" to={to} c={c} inherit>
          {pageTitle}
        </Anchor>
      ) : (
        <Text component="span" fw="bold" c={c} inherit>
          {pageTitle}
        </Text>
      )}
    </PageTitle>
  );
};

const PageTitle = ({ children, ...props }: TitleProps) => {
  const { gray } = useLegacyColors();

  return (
    <Title
      fw={400}
      c={gray.dark + 90}
      order={1}
      data-testid={'page-breadcrumbs'}
      size="1.5rem"
      {...props}
    >
      {children}
    </Title>
  );
};
